var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-row',[_c('w-col',{attrs:{"xs":"12"}},[_c('app-stock-location-select',{attrs:{"multi":"","label":_vm.label,"fancy":"","value":_vm.val}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }